import {ErrorType} from "config/errors";

export const getSessionState = () => {
    try {
        if (sessionStorage.getItem("state")) {
            // @ts-ignore
            return JSON.parse(sessionStorage.getItem("state"));
        }
    } catch (error) {
        import("config/sentry").then(({notify}) => {
            notify("Unable to read state from session storage", ErrorType.SESSION_STORAGE_ACCESS_DENIED, {
                error,
            });
        });
    }

    return null;
};
